import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { ResponsiveBlockGrid } from "../../../shared/components/ResponsiveBlockGrid/ResponsiveBlockGrid";
import { ResponsiveBlockGridItem } from "../../../shared/components/ResponsiveBlockGridItem/ResponsiveBlockGridItem";
import { IconContentGridCard } from "../IconContentGridCard/IconContentGridCard";
import type { IIconContentGridStandardProps } from "./IconContentGridStandard.props";

export const IconContentGridStandard = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  spacing,
}: IIconContentGridStandardProps) => {
  const hasCommonContent = Boolean(eyebrow || heading || description);
  const hasActions = Boolean(buttons?.length);
  const hasIntroContent = hasCommonContent || hasActions;

  return (
    <BlockContainer anchorId={anchorId} spacing={spacing}>
      <BlockCommonContent
        alignment={alignment}
        description={description}
        eyebrow={eyebrow}
        heading={heading}
        headingLevel="h2"
      />
      {buttons?.length ? (
        <BlockActions
          actions={buttons}
          alignment={alignment}
          className={hasCommonContent ? "mt-8" : undefined}
        />
      ) : null}
      <ResponsiveBlockGrid
        className={hasIntroContent ? "mt-12 gap-x-6 gap-y-8 md:mt-16" : "gap-x-6 gap-y-8"}
        columnCount={columnCount}
      >
        {items.map((item, index) => (
          <ResponsiveBlockGridItem key={`${item.heading}-${index}`} span={item.columnSpan}>
            <IconContentGridCard {...item} />
          </ResponsiveBlockGridItem>
        ))}
      </ResponsiveBlockGrid>
    </BlockContainer>
  );
};

IconContentGridStandard.displayName = "IconContentGrid::IconContentGridStandard";
